import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { ImageButtonConteinerProtocol } from '../../../assets/styles/image_style';
import { functionsUseFul } from 'views/Protocol/list/assets/functionsUseFul';
import { dateRules } from 'views/Protocol/form/assets/functions';
import { ErrorFormMessage } from 'components/ErrorFormMessage';
import SimpleHeader from 'components/Headers/SimpleHeader';
import { ErrorMessage } from '@hookform/error-message';
import { Controller, useForm } from 'react-hook-form';
import DatePicker from 'components/Inputs/DatePicker';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { individual_column_style } from 'assets/styles/table_custom_style';
import Pagination from 'components/Pagination';
import Loader from 'react-loader-spinner';
import ScalesService from './service';
import { useGetTeams } from '../../User/form/hooks/useGetTeams';
import { useGetScales } from '../../../hooks/useGetScales';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Form,
  Input
} from 'reactstrap';
import FlexSelect from 'components/Inputs/FlexSelect';
import { ItemPerPageSelect } from 'components/Inputs/ItemPerPageSelect';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { toast } from 'react-toastify';
import {
  useMemorizeFilters,
  POSSIBLE_FILTERS_ENTITIES
} from 'hooks/useMemorizeInputsFilters';
import { ClearFiltersButton } from 'components/ClearFiltersButton';
import { InadherenceCheckbox } from 'components/InadherenceCheckbox';

export const ScalesReportTeams = () => {
  const { getDateBegin } = functionsUseFul();
  const { getMemorizedFilters, memorizeFilters, clearMemorizedFilters } =
    useMemorizeFilters(POSSIBLE_FILTERS_ENTITIES.REPORT_WORK_SCHEDULE_TEAMS);
  const memorizedFilters = getMemorizedFilters() || {};

  const [data, setData] = useState([]);
  const [activePage, setActivePage] = useState(memorizedFilters.page ?? 1);
  const [quantity, setQuantity] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [dataToSend, setDataToSend] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(memorizedFilters.size ?? 10);
  const { teams } = useGetTeams();
  const { scales } = useGetScales();
  const [hasNonAdherent, setHasNonAdherent] = useState(
    memorizedFilters.hasNonAdherent ?? false
  );
  const [minAbsencePercentage, setMinAbsencePercentage] = useState(
    memorizedFilters.minAbsencePercentage ?? ''
  );

  const toISOFormat = useCallback((dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');
    if (bar) return `${YYYY}/${MM}/${DD}`;
    return `${YYYY}-${MM}-${DD}`;
  }, []);

  const getMinAbsencePercentageValue = useCallback(() => {
    if (minAbsencePercentage === '') return null;
    const parsedValue = Number(minAbsencePercentage);
    return Number.isNaN(parsedValue) ? null : parsedValue;
  }, [minAbsencePercentage]);

  const applyLocalFilters = useCallback(
    (rows) => {
      let filteredData = rows;

      if (hasNonAdherent) {
        filteredData = filteredData.filter((row) => row.nonAdherentTime > 0);
      }

      const minimumAbsence = getMinAbsencePercentageValue();
      if (minimumAbsence !== null) {
        filteredData = filteredData.filter(
          (item) => item.absenceTotalPercentage >= minimumAbsence
        );
      }

      return filteredData;
    },
    [getMinAbsencePercentageValue, hasNonAdherent]
  );

  const getReports = useCallback(
    ({
      currentPage = activePage,
      size = itemsPerPage,
      payload = dataToSend
    }) => {
      if (!payload) return;

      setIsLoading(true);
      ScalesService.getAllSearchScale(false, size, currentPage, payload)
        .then((res) => {
          setQuantity(res.data.totalRegisters);
          setData(applyLocalFilters(res.data.data));
        })
        .catch((err) => {
          console.log(err);
          toast.error(
            err || 'Ocorreu um erro por favor entre em contato com o suporte'
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [activePage, applyLocalFilters, dataToSend, itemsPerPage]
  );

  const getCurrentFiltersToMemorize = useCallback(
    (data, page = 1, size = itemsPerPage) => ({
      ...data,
      page,
      size,
      hasNonAdherent,
      minAbsencePercentage
    }),
    [hasNonAdherent, itemsPerPage, minAbsencePercentage]
  );

  const onSubmit = (data, isManualSubmit = true) => {
    const pageSavedOnMemory = isManualSubmit
      ? 1
      : getMemorizedFilters()?.page ?? 1;
    const sizeSavedOnMemory = getMemorizedFilters()?.size ?? itemsPerPage;
    memorizeFilters(
      getCurrentFiltersToMemorize(data, pageSavedOnMemory, sizeSavedOnMemory)
    );

    const formatedData = formatData(data);
    setDataToSend(formatedData);
    setActivePage(pageSavedOnMemory);
    setIsLoading(true);
    ScalesService.getAllSearchScale(
      false,
      sizeSavedOnMemory,
      pageSavedOnMemory,
      formatedData
    )
      .then((res) => {
        const filteredData = applyLocalFilters(res.data.data);

        if (
          isManualSubmit &&
          (res.data.totalRegisters === 0 || filteredData.length === 0)
        ) {
          toast.info('Nenhum registro encontrado');
        }

        setQuantity(res.data.totalRegisters);
        setData(filteredData);
      })
      .catch((err) => {
        console.log('err', err);
        toast.error(
          err || 'Ocorreu um erro por favor entre em contato com o suporte'
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const formatData = (formData) => {
    const data = { ...formData };
    data.beginDate = new Date(toISOFormat(data.beginDate)).toISOString();
    data.endDate = new Date(toISOFormat(data.endDate)).toISOString();

    if (data.teams && data.teams.length > 0) {
      data.teams = JSON.stringify(data.teams);
    }
    if (data.scales && data.scales.length > 0) {
      data.scales = JSON.stringify(data.scales);
    }

    if (!data.teams) data.teams = '[]';
    if (!data.scales) data.scales = '[]';

    return data;
  };

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const { control, handleSubmit, getValues, setValue, errors } = useForm({
    defaultValues: {
      beginDate: memorizedFilters.beginDate ?? getDateBegin(),
      endDate:
        memorizedFilters.endDate ?? new Date().toLocaleDateString('pt-br'),
      teams: memorizedFilters.teams ?? '',
      scales: memorizedFilters.scales ?? '',
      hasNonAdherent: memorizedFilters.hasNonAdherent ?? false
    }
  });

  const handlePageChange = (page) => {
    setActivePage(page);
    const prevFilters = getMemorizedFilters();
    memorizeFilters({ ...prevFilters, page, size: itemsPerPage });
    getReports({ currentPage: page });
  };

  const formatPercentage = (number) => {
    return number || number === 0 ? number + '%' : '-';
  };

  const handleReset = () => {
    const defaultFieldValues = {
      beginDate: getDateBegin(),
      endDate: new Date().toLocaleDateString('pt-br'),
      teams: '',
      scales: ''
    };

    for (const key in defaultFieldValues) {
      setValue(`${key}`, defaultFieldValues[key]);
    }

    clearMemorizedFilters();
    setHasNonAdherent(false);
    setMinAbsencePercentage('');
    setItemsPerPage(10);
    setActivePage(1);
    setData([]);
    setQuantity(0);
    setDataToSend(null);
  };

  function converterMinutesToHMS(minutes) {
    let totalSeconds = minutes * 60;

    let hours = Math.floor(totalSeconds / 3600);
    let minutesLeft = Math.floor((totalSeconds % 3600) / 60);
    let seconds = Math.floor(totalSeconds % 60);

    let hh = String(hours).padStart(2, '0');
    let mm = String(minutesLeft).padStart(2, '0');
    let ss = String(seconds).padStart(2, '0');

    return minutes >= 0 ? `${hh}:${mm}:${ss}` : '-';
  }

  useEffect(() => {
    if (scales.length > 0) {
      const formValues = getValues();
      onSubmit(formValues, false);
    }
  }, [scales]);

  useEffect(() => {
    if (!dataToSend) return;

    setActivePage(1);
    const currentFilters = getValues();
    memorizeFilters(
      getCurrentFiltersToMemorize(currentFilters, 1, itemsPerPage)
    );
    getReports({ currentPage: 1, size: itemsPerPage });
  }, [
    getCurrentFiltersToMemorize,
    getReports,
    getValues,
    hasNonAdherent,
    itemsPerPage,
    minAbsencePercentage,
    memorizeFilters
  ]);

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <div className="d-flex flex-row justify-content-between">
                    <h3 className="mb-0">Relatório de Escalas por Equipe</h3>
                  </div>
                </CardHeader>
                <CardBody className="pt-2">
                  <Form
                    className="needs-validation"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <ClearFiltersButton handleOnClick={handleReset} />
                    <Row className="mb-3">
                      <Col md={{ size: 6 }}>
                        <label className="form-control-label">
                          Data inicial *
                        </label>
                        <Controller
                          render={(props) => (
                            <DatePicker
                              fieldName="beginDate"
                              valueController={(fieldName, value) => {
                                setValue(fieldName, value);
                              }}
                              defaultValue={props.value}
                            />
                          )}
                          control={control}
                          name="beginDate"
                          defaultValue={
                            getMemorizedFilters()?.beginDate ?? getDateBegin()
                          }
                          rules={dateRules}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="beginDate"
                          render={({ message }) => (
                            <ErrorFormMessage message={message} />
                          )}
                        />
                      </Col>
                      <Col md={{ size: 6 }}>
                        <label className="form-control-label">
                          Data final *
                        </label>
                        <Controller
                          render={(props) => (
                            <DatePicker
                              fieldName="endDate"
                              valueController={(fieldName, value) => {
                                setValue(fieldName, value);
                              }}
                              defaultValue={props.value}
                            />
                          )}
                          control={control}
                          name="endDate"
                          defaultValue={
                            getMemorizedFilters()?.endDate ??
                            new Date().toLocaleDateString('pt-br')
                          }
                          rules={{
                            ...dateRules,
                            validate: async (value) => {
                              if (
                                new Date(await toISOFormat(value, true)) <
                                new Date(
                                  await toISOFormat(
                                    getValues()['beginDate'],
                                    true
                                  )
                                )
                              ) {
                                return 'A data final não pode ser anterior à inicial!';
                              } else {
                                return true;
                              }
                            }
                          }}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="endDate"
                          render={({ message }) => (
                            <ErrorFormMessage message={message} />
                          )}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="6">
                        <label className="form-control-label">Equipes</label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              isClearable={true}
                              dataOptions={teams}
                              isMulti={true}
                              closeMenuOnSelect={false}
                              value={props.value}
                              valueController={setValue}
                              fieldName="teams"
                              labelName="name"
                              valueName="id"
                            />
                          )}
                          control={control}
                          name="teams"
                          defaultValue={getMemorizedFilters()?.teams ?? ''}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="teams"
                          render={({ message }) => (
                            <ErrorFormMessage message={message} />
                          )}
                        />
                      </Col>

                      <Col md="6">
                        <label className="form-control-label">Escala</label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              isClearable={true}
                              dataOptions={scales}
                              isMulti={true}
                              closeMenuOnSelect={false}
                              value={props.value}
                              valueController={setValue}
                              fieldName="scales"
                              labelName="name"
                              valueName="id"
                            />
                          )}
                          control={control}
                          name="scales"
                          defaultValue={getMemorizedFilters()?.scales ?? ''}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="scales"
                          render={({ message }) => (
                            <ErrorFormMessage message={message} />
                          )}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="6">
                        <label className="form-control-label">
                          % Mínimo de Absenteísmo
                        </label>
                        <Input
                          type="number"
                          min="0"
                          max="100"
                          step="0.01"
                          placeholder="Ex: 0.5"
                          value={minAbsencePercentage}
                          onChange={(e) => {
                            setMinAbsencePercentage(e.target.value);
                          }}
                        />
                        <small className="form-text text-muted">
                          Exibir apenas equipes com absenteísmo acima deste
                          percentual
                        </small>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="12">
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            columnGap: '24px',
                            rowGap: '10px',
                            alignItems: 'center'
                          }}
                        >
                          <InadherenceCheckbox
                            hasNonAdherent={hasNonAdherent}
                            setHasNonAdherent={setHasNonAdherent}
                          />
                        </div>
                      </Col>
                    </Row>

                    <div
                      className="mt-3"
                      style={{
                        ...ImageButtonConteinerProtocol,
                        justifyContent: 'flex-start',
                        gap: '8px'
                      }}
                    >
                      <Button
                        style={buttonStyle(systemConfiguration.primary_color)}
                        type="submit"
                        size="sm"
                      >
                        Filtrar protocolos
                      </Button>
                      <ItemPerPageSelect
                        entity={
                          POSSIBLE_FILTERS_ENTITIES.REPORT_WORK_SCHEDULE_TEAMS
                        }
                        valueController={setItemsPerPage}
                      />
                    </div>
                  </Form>
                </CardBody>
                {data && data.length > 0 ? (
                  isLoading ? (
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  ) : (
                    <>
                      <ToolkitProvider
                        data={data}
                        keyField="id"
                        columns={[
                          {
                            dataField: 'name',
                            text: 'Equipe',
                            sort: true,
                            style: individual_column_style
                          },
                          {
                            dataField: 'totalHired',
                            text: 'Tempo total contratado',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.totalHired || row.totalHired == 0
                                ? converterMinutesToHMS(row.totalHired)
                                : '-';
                            }
                          },
                          {
                            dataField: 'overtimeTotalHired',
                            text: 'Tempo de hora extra solicitado',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.overtimeTotalHired ||
                                row.overtimeTotalHired == 0
                                ? converterMinutesToHMS(row.overtimeTotalHired)
                                : '-';
                            }
                          },
                          {
                            dataField: 'totalHiredWithOvertime',
                            text: 'Tempo total contratado com hora extra',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.totalHiredWithOvertime ||
                                row.totalHiredWithOvertime == 0
                                ? converterMinutesToHMS(
                                    row.totalHiredWithOvertime
                                  )
                                : '-';
                            }
                          },
                          {
                            dataField: 'overtimeTotal',
                            text: 'Tempo de hora extra efetivo',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.overtimeTotal || row.overtimeTotal == 0
                                ? converterMinutesToHMS(row.overtimeTotal)
                                : '-';
                            }
                          },
                          {
                            dataField: 'automaticPauseTotalHired',
                            text: 'Tempo total de pausa automática',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.automaticPauseTotalHired ||
                                row.automaticPauseTotalHired == 0
                                ? converterMinutesToHMS(
                                    row.automaticPauseTotalHired
                                  )
                                : '-';
                            }
                          },
                          {
                            dataField: 'loggedTotal',
                            text: 'Tempo total logado',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.loggedTotal || row.loggedTotal == 0
                                ? converterMinutesToHMS(row.loggedTotal)
                                : '-';
                            }
                          },
                          {
                            dataField: 'loggedWithoutOvertimeTotal',
                            text: 'Tempo total logado sem hora extra',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.loggedWithoutOvertimeTotal ||
                                row.loggedWithoutOvertimeTotal == 0
                                ? converterMinutesToHMS(
                                    row.loggedWithoutOvertimeTotal
                                  )
                                : '-';
                            }
                          },
                          {
                            dataField: 'pausedTotal',
                            text: 'Tempo total pausado',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.pausedTotal || row.pausedTotal == 0
                                ? converterMinutesToHMS(row.pausedTotal)
                                : '-';
                            }
                          },
                          {
                            dataField: 'automaticPauseTotal',
                            text: 'Tempo total pausado por pausa automática',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.automaticPauseTotal ||
                                row.automaticPauseTotal == 0
                                ? converterMinutesToHMS(row.automaticPauseTotal)
                                : '-';
                            }
                          },
                          {
                            dataField: 'loggedPercentage',
                            text: 'percentual logado',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return formatPercentage(row.loggedPercentage);
                            }
                          },
                          {
                            dataField: 'loggedWithoutOvertimePercentage',
                            text: 'percentual logado sem hora extra',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return formatPercentage(
                                row.loggedWithoutOvertimePercentage
                              );
                            }
                          },
                          {
                            dataField: 'absenceTotalPercentage',
                            text: 'percentual de absenteísmo',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return formatPercentage(
                                row.absenceTotalPercentage
                              );
                            }
                          },
                          {
                            dataField: 'absenceWithoutPauseTotalPercentage',
                            text: 'percentual de absenteísmo sem tempo de pausa',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return formatPercentage(
                                row.absenceWithoutPauseTotalPercentage
                              );
                            }
                          },
                          {
                            dataField: 'conversationPercentage',
                            text: 'percentual de conversação em relação ao tempo contratado',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return formatPercentage(
                                row.conversationPercentage
                              );
                            }
                          },
                          {
                            dataField: 'conversationPercentageWithoutPause',
                            text: 'percentual de conversação sem pausa',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return formatPercentage(
                                row.conversationPercentageWithoutPause
                              );
                            }
                          },
                          {
                            dataField: 'nonAdherentTime',
                            text: 'Tempo inaderente',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return row.nonAdherentTime ||
                                row.nonAdherentTime == 0
                                ? converterMinutesToHMS(row.nonAdherentTime)
                                : '-';
                            }
                          },
                          {
                            dataField: 'adherentTimePercentage',
                            text: 'Percentual Tempo Inaderente',
                            sort: true,
                            style: individual_column_style,
                            formatter: (_, row) => {
                              return formatPercentage(
                                row.adherentTimePercentage
                              );
                            }
                          }
                        ]}
                      >
                        {(props) => (
                          <div style={{ overflow: 'auto' }}>
                            <BootstrapTable
                              {...props.baseProps}
                              bootstrap4={true}
                              bordered={false}
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                      <Pagination
                        itemsCountPerPage={itemsPerPage}
                        activePage={activePage}
                        totalItemsCount={quantity}
                        onChange={handlePageChange.bind(this)}
                      />
                    </>
                  )
                ) : null}
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};
